module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [(_vm.configObj.showAddress) ? [(_vm.haveSetAddress) ? _c('c-panel-container', [_c('c-panel', {
    attrs: {
      "title": _vm.showUserBaseInfo,
      "desc": _vm.showUserAddress
    },
    nativeOn: {
      "click": function($event) {
        _vm.editAddress($event)
      }
    }
  }, [_c('div', {
    staticClass: "right-point"
  })])], 1) : _c('c-cell-container', {
    staticClass: "mg-0"
  }, [_c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "icon": require('../../../assets/images/icon/plus-icon.svg'),
      "title": "设置收货地址"
    },
    nativeOn: {
      "click": function($event) {
        _vm.editAddress($event)
      }
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('c-panel-container', [_c('c-panel', {
    attrs: {
      "title": _vm.goodsName,
      "desc": ("x " + _vm.goodsCount),
      "img": _vm.goodsIcon
    }
  }, [_c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.goodsPrice)))])]), _vm._v(" "), _c('c-panel', {
    attrs: {
      "title": "",
      "desc": ""
    }
  }, [_vm._v("\n          共" + _vm._s(_vm.goodsCount) + "件商品 小计:\n          "), _c('div', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.goodsTotalPrice)))])])], 1), _vm._v(" "), _c('c-cell-container', [(_vm.configObj.showAddress) ? [_c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "title": "运费",
      "desc": _vm.goodsMailPriceText,
      "point": false
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.notUseTicket && _vm.ticketCount > 0) ? _c('c-cell', {
    staticClass: "cell-item",
    attrs: {
      "title": "礼金券",
      "desc": _vm.couponSelected ? ((_vm.couponSelected.price) + "元") : (_vm.ticketCount + "张可用")
    },
    nativeOn: {
      "click": function($event) {
        _vm.selectGoodsTicket($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.notUseIntegral && _vm.accountIntegral > 0) ? _c('div', {
    staticClass: "weui-cell weui-cell_switch cell-item"
  }, [_c('div', {
    staticClass: "weui-cell__bd"
  }, [_vm._v("可用 " + _vm._s(_vm.accountIntegral) + "积分 抵 " + _vm._s(_vm.intergralToCurrency) + " 元 "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.useIntegral),
      expression: "useIntegral"
    }]
  }, [_vm._v("(剩余" + _vm._s(_vm.remainingIntegral) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__ft",
    staticStyle: {
      "font-size": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.useIntegral),
      expression: "useIntegral"
    }],
    staticClass: "weui-switch",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.useIntegral) ? _vm._i(_vm.useIntegral, null) > -1 : (_vm.useIntegral)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.useIntegral,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.useIntegral = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.useIntegral = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.useIntegral = $$c
        }
      }
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.configObj.showRemark) ? [_c('c-form', [_c('div', {
    staticClass: "weui-cell cell-item"
  }, [_c('div', {
    staticClass: "weui-cell__hd"
  }, [_c('label', {
    staticClass: "weui-label"
  }, [_vm._v("买家留言")])]), _vm._v(" "), _c('div', {
    staticClass: "weui-cell__bd"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "weui-input",
    attrs: {
      "type": "text",
      "placeholder": "选填，可输入对本次交易的说明"
    },
    domProps: {
      "value": (_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])])])] : _vm._e()], 2), _vm._v(" "), _c('c-footer', [_c('div', {
    staticClass: "pay"
  }, [_c('div', {
    staticClass: "total-price"
  }, [_c('span', {
    staticClass: "price-text"
  }, [_vm._v("实付：")]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("currency0")(_vm.goodsFinalPrice)))])]), _vm._v(" "), _c('div', {
    staticClass: "pay-btn",
    on: {
      "click": _vm.payProcess
    }
  }, [_vm._v("\n          立即支付\n        ")])])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-right",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05da844c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/confirm/index.vue
// module id = 1015
// module chunks = 2